import { render, staticRenderFns } from "./filter-menu.vue?vue&type=template&id=c6a52f72&scoped=true&"
import script from "./filter-menu.vue?vue&type=script&lang=js&"
export * from "./filter-menu.vue?vue&type=script&lang=js&"
import style0 from "./filter-menu.vue?vue&type=style&index=0&id=c6a52f72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6a52f72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6a52f72')) {
      api.createRecord('c6a52f72', component.options)
    } else {
      api.reload('c6a52f72', component.options)
    }
    module.hot.accept("./filter-menu.vue?vue&type=template&id=c6a52f72&scoped=true&", function () {
      api.rerender('c6a52f72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/elements/filter-menu.vue"
export default component.exports